let ModalSize = /*#__PURE__*/function (ModalSize) {
  ModalSize[ModalSize["Small"] = 1] = "Small";
  ModalSize[ModalSize["Medium"] = 2] = "Medium";
  ModalSize[ModalSize["Large"] = 3] = "Large";
  return ModalSize;
}({});

export { ModalSize };
//# sourceMappingURL=modal-size.js.map
